import React, { useRef } from 'react';
import vid from './converters.mp4'; 
import './typingadd.css';
import { useNavigate } from 'react-router-dom';
export default function Convertersadd() {
  const videoRef = useRef(null);

  const handleLoadedData = () => {
    if (videoRef.current) {
      videoRef.current.play(); 
    }
  };
  const navigate=useNavigate();
const handleadd =()=>{
    navigate(`/imagetopdf`)
}

  return (
    <>
      <section id="typingadd-section" >
        <div id="typingadd-cont" onClick={handleadd}>
          <h3>
            Convert Your Images Into Pdf And Many More Converters <span title='Click Now' >Try Now</span>
          </h3>
          <video
            ref={videoRef}
            src={vid}
            width="260px"
            height="150px"
            loop
            autoPlay
            muted
            onLoadedData={handleLoadedData}
          ></video>
          </div>
      </section>
    </>
  );
}
